import React from "react";
import { Radio, Space } from "antd";

export default function StepObjective({ value, onPick }) {
  return (
    <Radio.Group
      value={value}
      onChange={(e) => onPick(e.target.value)}
      style={{ width: "100%" }}
    >
      <Space direction="vertical" size={12} style={{ width: "100%" }}>
        <Radio className="bv-radio" value="leitura">
          Leitura
        </Radio>
        <Radio className="bv-radio" value="computador">
          Trabalhar em frente ao computador
        </Radio>
        <Radio className="bv-radio" value="presbiopia">
          Corrigir presbiopia (dificuldade pra perto e longe)
        </Radio>
        <Radio className="bv-radio" value="orientacao">
          Não sei, preciso de orientação
        </Radio>
      </Space>
    </Radio.Group>
  );
}